/** Namespace `bankHubLab` — HQ-2026-011: « Phòng thử SePay Bank Hub » cho MỘT bộ thông số. Bản gốc tiếng Việt. */
export const bankHubLab = {
  title: "Phòng thử SePay Bank Hub",
  subtitle: "Bộ « {name} » · {env} · {product}",
  hostEnv: "môi trường theo host: {env}",
  intro:
    "Gọi THẬT API Bank Hub bằng bộ thông số này, trước khi gán cho app. Nút đỏ tạo / sửa / thu hồi thứ có thật ở SePay — bấm hai lần; máy chủ đòi xác nhận và ghi audit (không ghi tham số).",
  readOnlyRole: "Vai trò của bạn chỉ xem được — gọi SePay cần quyền ghi tích hợp (dùng khoá đã lưu của bộ).",
  notFound: "Không tìm thấy bộ thông số này (hoặc không phải sản phẩm SePay Bank Hub).",
  envMismatchTitle: "Môi trường của bộ lệch host — máy chủ chặn mọi hành động ghi",
  infoFailed: "Không đọc được thông tin phòng thử: {error}",
  infoLoading: "Đang tải thông tin phòng thử…",
  "shared.title": "Client ID này đang phục vụ app",
  "shared.row": "{app} · {env} · bộ « {set} »",
  "shared.sameSet": "(chính bộ này)",
  "shared.grace": "(đang ân hạn)",
  "shared.help":
    "SePay giữ MỘT webhook sự kiện và MỘT bộ lọc từ khoá IPN cho mỗi Client ID — trỏ webhook về phòng thử hay sửa cấu hình merchant sẽ lấy mất tin của app, nên máy chủ chặn hai việc đó.",
  "channel.ipn.title": "IPN biến động số dư",
  "channel.ipn.help":
    "Dán URL này vào portal SePay › Bank Hub › « Cấu hình Webhook » › « Notify URL » (không có API đặt URL IPN). « Notify API Key » ở đó phải trùng « Khoá IPN » (ipnApiKey) của bộ. Mỗi merchant một Notify URL — đổi sang phòng thử là IPN của app dùng cùng Client ID không tới app nữa.",
  "channel.events.title": "Sự kiện liên kết (BANK_ACCOUNT_*, LINK_*)",
  "channel.events.help": "Đặt bằng « Cập nhật webhook » (nhóm Merchant) — mỗi Client ID một URL, ghi đè URL cũ và có hiệu lực ngay.",
  "channel.auth": "SePay gửi header {header}",
  "channel.keyHint": "khoá phòng thử kiểm: {hint}",
  "channel.keyMissing": "Bộ chưa điền khoá của kênh này — mọi tin gửi tới sẽ bị từ chối (401).",
  "channel.urlFallback": "Máy chủ hub chưa khai HQ_PUBLIC_API_URL — URL ghép từ địa chỉ dashboard; SePay chỉ gọi URL https:// công khai.",
  "channel.openWebhookForm": "Mở « Cập nhật webhook »",
  flows: "Kịch bản",
  "flow.suite": "Chạy thử đủ API đọc",
  "flow.link": "Phiên liên kết TK (Hosted Link)",
  "help.suite":
    "Chạy liền MỌI API chỉ đọc, cỡ trang nhỏ, cách nhau ≥ 350 ms — không đổi gì ở SePay. Bước chi tiết dùng công ty / TK / giao dịch đầu tiên của bước danh sách.",
  "help.link":
    "Kiểm webhook sự kiện ⇒ chọn / tạo công ty ⇒ tạo link token ⇒ Hosted Link trong khung ⇒ chờ sự kiện BANK_ACCOUNT_* về phòng thử ⇒ đọc chi tiết TK. Trên Live, người hoàn tất phiên liên kết / huỷ liên kết TK ngân hàng THẬT.",
  "section.read": "Đọc (không đổi gì)",
  "section.company": "Công ty",
  "section.link": "Liên kết (link token)",
  "section.merchant": "Merchant (cả Client ID)",
  "action.token": "Lấy token",
  "action.companies": "Danh sách công ty",
  "action.company": "Chi tiết công ty",
  "action.companyCounter": "Bộ đếm giao dịch công ty",
  "action.bankAccounts": "Danh sách TK ngân hàng",
  "action.bankAccount": "Chi tiết TK ngân hàng",
  "action.transactions": "Danh sách giao dịch",
  "action.transaction": "Chi tiết giao dịch",
  "action.merchantConfig": "Cấu hình merchant",
  "action.webhook": "Webhook sự kiện hiện tại",
  "action.linkTokenGet": "Thông tin link token",
  "action.companyCreate": "Tạo công ty",
  "action.companyEdit": "Sửa công ty",
  "action.linkTokenCreate": "Tạo link token",
  "action.linkTokenRevoke": "Thu hồi link token",
  "action.merchantConfigUpdate": "Sửa cấu hình merchant",
  "action.webhookUpdate": "Cập nhật webhook",
  "scope.session": "Ảnh hưởng MỘT phiên liên kết — trên Live, người hoàn tất phiên liên kết / huỷ liên kết TK ngân hàng thật.",
  "scope.company":
    "Ảnh hưởng MỘT công ty — status / hạn mức giao dịch có thể làm SePay NGỪNG gửi IPN cho mọi TK của công ty. SePay không có API xoá công ty.",
  "scope.merchant": "Ảnh hưởng CẢ merchant (mọi công ty dùng Client ID này): webhook sự kiện, bộ lọc từ khoá IPN.",
  "hint.token": "Máy chủ chỉ trả ttl — access token không bao giờ rời máy chủ.",
  "hint.companyCounter": "Bỏ trống ngày = mọi ngày.",
  "hint.bankAccount": "CCCD và số điện thoại đã được che trước khi trả.",
  "hint.transactions": "Ngày: yyyy-mm-dd (tài liệu SePay chỉ ghi dạng này). webhookSuccess = 0 ⇒ giao dịch SePay gửi IPN không thành — dấu hiệu IPN trỏ sai chỗ.",
  "hint.linkTokenGet": "Dùng chuỗi link_token (UUID) trả từ « Tạo link token » — không phải xid.",
  "hint.linkTokenRevoke": "Không hoàn tác được — ngắt người đang ở trong phiên. Dùng xid của link token, không phải chuỗi link_token.",
  "hint.companyEdit":
    "Tài liệu SePay chỉ ghi status Active / Pending. Suspended: đã đo trên sandbox 2026-10-16 — SePay nhận, « Chi tiết công ty » sau đó trả Suspended; IPN có thật sự ngừng thì CHƯA đo. Giá trị khác chưa đo. Hạn mức giao dịch: Unlimited hoặc số; 0 ⇒ SePay ngừng gửi IPN cho công ty.",
  "hint.merchantConfigUpdate":
    "Mỗi dòng (hoặc phẩy) một từ khoá. Danh sách rỗng ⇒ SePay gửi IPN mọi giao dịch; có từ khoá ⇒ chỉ giao dịch có nội dung chứa từ khoá — cho MỌI công ty.",
  "field.page": "Trang",
  "field.perPage": "Số dòng / trang",
  "field.q": "Tìm (q)",
  "field.status": "Trạng thái (status)",
  "field.companyXid": "xid công ty",
  "field.date": "Ngày (yyyy-mm-dd)",
  "field.bankId": "Mã ngân hàng (bank_id)",
  "field.bankAccountXid": "xid TK ngân hàng",
  "field.transferType": "Chiều (transfer_type)",
  "field.webhookSuccess": "Đã gửi IPN thành công (webhook_success)",
  "field.transactionDate": "Ngày giao dịch (yyyy-mm-dd)",
  "field.startTransactionDate": "Từ (yyyy-mm-dd)",
  "field.endTransactionDate": "Đến (yyyy-mm-dd)",
  "field.transactionId": "Mã giao dịch (transaction_id)",
  "field.fullName": "Tên đầy đủ (full_name, không trùng trong merchant)",
  "field.shortName": "Tên ngắn (short_name)",
  "field.transactionAmount": "Hạn mức giao dịch (Unlimited hoặc số)",
  "field.paymentCode": "Mã thanh toán (payment_code)",
  "field.paymentCodePrefix": "Tiền tố mã thanh toán (2–5 chữ)",
  "field.paymentCodeSuffixFrom": "Hậu tố từ (số ký tự)",
  "field.paymentCodeSuffixTo": "Hậu tố đến (số ký tự)",
  "field.paymentCodeSuffixCharacterType": "Kiểu ký tự hậu tố (vd NumberOnly)",
  "field.purpose": "Mục đích (purpose)",
  "field.completionRedirectUri": "URL quay về sau khi xong (https)",
  "field.isMobileApp": "Bản cho app di động",
  "field.language": "Ngôn ngữ trang",
  "field.linkToken": "link_token (UUID)",
  "field.linkTokenXid": "xid của link token",
  "field.transactionWhitelistRemarkKeywords": "Từ khoá lọc nội dung giao dịch",
  "form.required": "Thiếu « {field} ».",
  "form.notNumber": "« {field} » phải là số nguyên.",
  "account.inactive": "đang ngừng",
  "result.title": "Kết quả",
  "result.empty": "Chưa gọi API nào.",
  "result.noHttp": "không tới được SePay",
  "result.base": "{url} · {env}",
  "hosted.title": "Hosted Link SePay Bank Hub",
  "hosted.help":
    "Chọn ngân hàng, đăng nhập và xác nhận OTP trong trang của SePay. Tin trình duyệt chỉ là tín hiệu — nguồn tin cậy là sự kiện BANK_ACCOUNT_* về phòng thử.",
  "hosted.expired": "Phiên Hosted Link đã hết hạn — tạo link token mới.",
  "hosted.origin": "origin {origin}",
  "hosted.expiresAt": "hết hạn {at}",
  "hosted.signal": "Hosted Link báo: {name}",
  "hosted.newTab": "Mở trong tab mới",
  "hosted.close": "Đóng",
  "hosted.ready": "Đã tạo Hosted Link — origin {origin} thuộc danh sách của bộ.",
  "hosted.notAllowed":
    "Origin {origin} KHÔNG thuộc « Origin của Hosted Link » của bộ ({allowed}) — không nhúng vào khung. Kiểm URL trước khi mở tab mới; nếu đúng là của SePay thì thêm origin vào bộ.",
  "hosted.notAllowedShort": "origin {origin} không thuộc danh sách của bộ — không nhúng",
  "hosted.open": "Mở Hosted Link",
  "events.title": "Tin SePay đã gửi về (tự làm mới 3 giây)",
  "events.empty": "Chưa nhận tin nào.",
  "events.clear": "Xoá nhật ký",
  "col.time": "Lúc nhận",
  "col.kind": "Loại",
  "col.auth": "Khoá",
  "col.amount": "Số tiền",
  "col.account": "Tài khoản",
  "col.content": "Nội dung",
  verifiedYes: "Đúng khoá",
  verifiedNo: "Sai ({reason})",
  "wh.noTargets": "Máy chủ chưa trả đích webhook nào.",
  "wh.target": "Đích",
  "wh.targetLab": "Phòng thử của bộ này",
  "wh.targetApp": "App {app} (production, {env})",
  "wh.urlMissing": "(chưa có URL — hub chưa khai HQ_PUBLIC_API_URL hoặc app chưa khai URL)",
  "wh.active": "Bật (bỏ tích = tắt webhook)",
  "wh.events": "Sự kiện",
  "wh.eventsAll": "Mọi sự kiện (*)",
  "wh.eventsList": "Chọn từng sự kiện",
  "wh.reactivatedNote": "BANK_ACCOUNT_REACTIVATED không có trong danh sách SePay cho chọn lẻ (sai tên ⇒ 400) — muốn nhận nó thì chọn « Mọi sự kiện ».",
  "wh.needEvents": "Chọn ít nhất một sự kiện.",
  "wh.receiverOther": "Bên nhận kiểm X-Secret-Key bằng bộ KHÁC bộ đang thử — sự kiện sẽ bị bên nhận từ chối.",
  "wh.serverBuilds":
    "URL và secret_key do MÁY CHỦ ghép (X-Secret-Key = Khoá sự kiện của bộ). Kết quả kèm URL cũ (previous) để khôi phục.",
  "wh.readCurrent": "Đọc webhook hiện tại",
  "ptr.none": "Chưa đặt webhook sự kiện.",
  "ptr.lab": "Đang trỏ về phòng thử của bộ này (sự kiện: {events}).",
  "ptr.app": "Đang trỏ về app {app} — sự kiện KHÔNG về phòng thử.",
  "ptr.other": "Đang trỏ về nơi khác: {url}",
  "ptr.inactive": "webhook đang TẮT",
  "suite.ttl": "token sống {s} giây",
  "suite.rows": "{n} dòng",
  "suite.afterTokenFailed": "Bỏ qua — lấy token hỏng.",
  "suite.needId": "Bỏ qua — chưa có {what}.",
  "suite.summary": "Đạt {ok} · hỏng {failed} · bỏ qua {skipped}",
  "need.companyXid": "công ty nào (danh sách rỗng)",
  "need.bankAccountXid": "TK ngân hàng nào (danh sách rỗng)",
  "need.transactionId": "giao dịch nào (danh sách rỗng)",
  "need.linkToken": "link token (tạo ở « Phiên liên kết TK » hoặc « Tạo link token » trước)",
  "link.step.webhook": "Webhook sự kiện trỏ về phòng thử",
  "link.step.company": "Công ty",
  "link.step.session": "Tạo link token",
  "link.step.hosted": "Hosted Link",
  "link.step.event": "Chờ sự kiện BANK_ACCOUNT_*",
  "link.step.account": "Đọc chi tiết TK",
  "link.noXid": "SePay không trả xid của công ty vừa tạo — xem khung Kết quả.",
  "link.companyCreated": "Đã tạo công ty {xid}.",
  "link.noHostedUrl": "Kết quả không có hosted_link_url https:// dùng được.",
  "link.expect": "chờ {events}",
  "link.revoked": "Đã thu hồi link token — chờ sự kiện LINK_TOKEN_REVOKED.",
  "link.restored": "Đã khôi phục phiên đang dở của tab này (link token {xid}) — vẫn chờ sự kiện của đúng phiên đó. « Làm lại từ đầu » để bỏ.",
  "link.restoredDone": "Đã khôi phục phiên trước của tab này (link token {xid}) — không còn chờ sự kiện; kết quả các bước ở trên. « Làm lại từ đầu » để tạo phiên mới.",
  "link.sandboxHint":
    "Sandbox: dùng TK demo + OTP cố định ở trang thông tin sandbox của SePay. Kích hoạt lại chỉ thử được với OCB / KienLongBank (huỷ liên kết trước rồi kích hoạt lại). Sandbox không giả lập được giao dịch / IPN.",
  "link.sandboxDocs": "Thông tin sandbox SePay",
  "link.eventsUnusable": "URL sự kiện của phòng thử không dùng được: {reason}",
  "link.webhookWarn":
    "Sự kiện chưa trỏ về phòng thử — bước « Chờ sự kiện » sẽ không tự xong. Đặt bằng « Cập nhật webhook » đích phòng thử (chỉ được khi Client ID không phục vụ app).",
  "link.allowEvents.none": "allow_events rỗng — SePay KHÔNG gửi sự kiện nào; đặt lại « Mọi sự kiện » bằng « Cập nhật webhook ».",
  "link.allowEvents.needAll":
    "phiên này chờ {events} — tên đó không chọn lẻ được, chỉ về khi webhook đặt « Mọi sự kiện » (allow_events [\"*\"]).",
  "link.allowEvents.missing": "allow_events không gồm {events} — SePay sẽ không gửi; đặt « Mọi sự kiện » hoặc thêm tên đó.",
  "link.company": "Công ty",
  "link.pickCompany": "— chọn công ty —",
  "link.noCompanies": "Merchant chưa có công ty nào.",
  "link.loadCompanies": "Nạp danh sách công ty",
  "link.newCompany": "Hoặc tạo công ty mới (tên đầy đủ)",
  "link.companyPermanent": "SePay không có API xoá công ty — công ty tạo ở đây tồn tại mãi.",
  "link.purpose": "Mục đích",
  "link.account": "TK ngân hàng",
  "link.pickAccount": "— chọn TK —",
  "link.noAccounts": "Công ty chưa có TK nào.",
  "link.loadAccounts": "Nạp TK của công ty",
  "link.reactivateHint": "Kích hoạt lại chỉ dùng cho TK đã bị NGỪNG do huỷ liên kết (OCB, MSB, KienLongBank, TPBank); TK khác ⇒ SePay trả 400.",
  "link.checkWebhook": "Kiểm webhook",
  "link.readSession": "Đọc phiên (link-token/get)",
  "link.reopen": "Mở lại Hosted Link",
  "link.start": "Tạo link token & mở Hosted Link",
  "link.needCompany": "Chọn hoặc tạo công ty trước.",
  "link.needAccount": "Chọn TK ngân hàng (bắt buộc khi huỷ liên kết / kích hoạt lại).",
  "purpose.LINK_BANK_ACCOUNT": "Liên kết TK",
  "purpose.UNLINK_BANK_ACCOUNT": "Huỷ liên kết TK",
  "purpose.REACTIVATE_BANK_ACCOUNT": "Kích hoạt lại TK",
} as const;
